import { BRIDGE_HEARTBEAT_RTT_SAMPLE_MAX } from './constants.js';

export function meanRttMs(samples: readonly number[]): number | undefined {
  if (samples.length === 0) return undefined;
  let sum = 0;
  for (const x of samples) sum += x;
  return sum / samples.length;
}

export function createRttSampleBuffer(maxSamples = BRIDGE_HEARTBEAT_RTT_SAMPLE_MAX): {
  push: (rttMs: number) => void;
  clear: () => void;
  mean: () => number | undefined;
} {
  const samples: number[] = [];

  return {
    push(rttMs: number): void {
      if (!Number.isFinite(rttMs) || rttMs < 0 || rttMs >= 600_000) return;
      samples.push(rttMs);
      if (samples.length > maxSamples) {
        samples.splice(0, samples.length - maxSamples);
      }
    },
    clear(): void {
      samples.length = 0;
    },
    mean(): number | undefined {
      return meanRttMs(samples);
    },
  };
}
